'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _timeStringBigger = require('./timeStringBigger');

var _timeStringBigger2 = _interopRequireDefault(_timeStringBigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (a, b) {
    if (a === b) {
        return false;
    }
    return !(0, _timeStringBigger2.default)(a, b);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/timeStringSmaller.js
// module id = 20
// module chunks = 0